// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__7m4hc","checkboxCol":"Table_checkboxCol__9JOHz","emailCol":"Table_emailCol__2A4GL","actionCol":"Table_actionCol__aYRA0"};